
export const PRIVATE_EVENT_BUDGET_RANGES = [
    { label: "$0 - $20", min: 0, max: 20 },
    { label: "$21 - $40", min: 21, max: 40 },
    { label: "$41 - $60", min: 41, max: 60 },
    { label: "$61 - $80", min: 61, max: 80 },
    { label: "$81 - $100", min: 81, max: 100 },
    { label: "$101 - $120", min: 101, max: 120 },
    { label: "$121 - $140", min: 121, max: 140 },
    { label: "$141 - $160", min: 141, max: 160 },
    { label: "$161 - $180", min: 161, max: 180 },
    { label: "$181 - $200", min: 181, max: 200 },
    { label: "$201 - $220", min: 201, max: 220 },
    { label: "$221 - $240", min: 221, max: 240 },
    { label: "$241 - $260", min: 241, max: 260 },
    { label: "$261 - $280", min: 261, max: 280 },
    { label: "$281 - $300", min: 281, max: 300 },
]

export const ROLES = Object.freeze({
    SEEKER : 'Seeker',
    ORGANIZER : 'Organizer',
    ORGANIZATION : 'Organization',
    ADMIN : 'Admin',
    GUEST: 'guest',
    PLANNER:'Event Planner'
})


export const CONTACT_US_REASONS = Object.freeze({
    EventRegistration : "Event Registration",
    AccountCreation : "Account Creation",
    EventSearch : "Searching for event",
    BillingIssue : "Billing Issue",
    Other : "Other"
})

export const WEBSITE =
    "https://cultureinyourcity.com/"
    //"https://renloc.vercel.app/"
    // "https://dev.renloc.com/"


// export const BASE_URL = "https://cultureinyourcity.com/";
export const BASE_URL = `${window.location.protocol}//${window.location.host}/`;

export const PUBLIC_ENDPOINTS = ['/auth/signup','/auth/email-verification'
    ,'/auth/login','/auth/forgot-password','/auth/forgot-password/change-password'
    ,'/auth/user-validation']


export const USER_IMAGE_UPLOADED_PATH = 'https://endpoint.cultureinyourcity.com/uploads/'
// export const USER_IMAGE_UPLOADED_PATH = 'https://endpoint.cultureinyourcity.com/uploads/'
/***
 * Media BaseUrl
 * @type {string}
 */
export const MEDIA_BASEURL = `${process.env.VUE_APP_API_URL}uploads/`
export const MEDIA_BASEURL_PLACEHOLDER = `https://cultureinyourcity.com/img/`
export const VALIDATION_MESSAGE_TIMEOUT = 7000
export const SUCCESS_REDIRECT_TIMEOUT = 2000

/***
 * Event images live in a private S3 bucket - the backend hands back a
 * ready-to-use, time-limited presigned URL for each uploaded image (see
 * EventService.resolveMediaDeep on the backend), not a bare filename. The
 * placeholder image is the one exception: it's never uploaded to S3, so
 * it's always served from this app's own public/ folder instead.
 * @type {string}
 */
export const AWS_URL = process.env.VUE_APP_AWS_URL || ''
export const EVENT_PLACEHOLDER_IMAGE = 'event-placeholder.png'

export const getEventImageUrl = (value) => {
    if (!value || value === EVENT_PLACEHOLDER_IMAGE) {
        return `/${EVENT_PLACEHOLDER_IMAGE}`
    }
    // Already a full URL (presigned S3 URL from the backend) - use as-is,
    // don't concatenate AWS_URL onto something that's already complete.
    if (/^https?:\/\//i.test(value)) {
        return value
    }
    // Fallback for any bare filename that slips through unpresigned.
    return `${AWS_URL}/${value}`
}
